import React from 'react';
import { MeetingCard, Meeting } from './MeetingCard';
import './MeetingSection.css';

interface MeetingSectionProps {
    title: string;
    meetings: Meeting[];
    onViewAll?: () => void;
    onMeetingClick?: (meeting: Meeting) => void;
    hideHeader?: boolean;
    upcomingSoonMeetingId?: number | string;
    getTimeUntilMeeting?: (scheduleStartDateTime: string) => string | null;
    onLocationClick?: (meetingId: number | string) => void;
    onCreateMeeting?: () => void;
    emptyMessage?: string;
    emptySubMessage?: string;
    showCreateButton?: boolean;
}

export const MeetingSection: React.FC<MeetingSectionProps> = ({
    title,
    meetings,
    onViewAll,
    onMeetingClick,
    hideHeader = false,
    upcomingSoonMeetingId,
    getTimeUntilMeeting,
    onLocationClick,
    onCreateMeeting,
    emptyMessage,
    emptySubMessage,
    showCreateButton = false
}) => {
    const renderEmptyState = () => {
        if (title === 'TODAY' && showCreateButton) {
            return (
                <div className="home-meeting-empty home-meeting-empty--today">
                    <div className="empty-icon">📅</div>
                    <div className="empty-title">
                        {emptyMessage || "오늘 예정된 모임이 없어요"}
                    </div>
                    <div className="empty-subtitle">
                        {emptySubMessage || "새로운 모임을 만들어 친구들과 함께해보세요!"}
                    </div>
                    {onCreateMeeting && (
                        <button className="empty-create-button" onClick={onCreateMeeting}>
                            + 모임 만들기
                        </button>
                    )}
                </div>
            );
        }

        return (
            <div className="home-meeting-empty">
                {emptyMessage || "일정이 없습니다"}
            </div>
        );
    };

    return (
        <div className="home-section">
            {!hideHeader && (
                <div className="home-section-header">
                    <span className="home-section-title">{title}</span>
                    {onViewAll && (
                        <span className="home-section-link" onClick={onViewAll}>
                            전체보기
                        </span>
                    )}
                </div>
            )}
            <div className="home-meeting-list">
                {meetings.length === 0 ? (
                    renderEmptyState()
                ) : (
                    meetings.map(meeting => (
                        <MeetingCard
                            key={meeting.id}
                            meeting={meeting}
                            onClick={onMeetingClick}
                            showUpcomingSoonBanner={meeting.id === upcomingSoonMeetingId}
                            timeUntilMeeting={
                                meeting.id === upcomingSoonMeetingId && meeting.scheduleStartDateTime && getTimeUntilMeeting
                                    ? getTimeUntilMeeting(meeting.scheduleStartDateTime)
                                    : undefined
                            }
                            onLocationClick={onLocationClick}
                        />
                    ))
                )}
            </div>
        </div>
    );
};
